/**
 * Guide engine v3 overlay - popup placement (#1025, epic #1020). Spec R1.6.
 *
 * The popup is positioned by `placement` percentages, fully DECOUPLED from the
 * highlight (no anchor, no tail, no flip / preventOverflow - the v1 popper
 * collision machinery is gone). Author places the popup at an explicit point.
 *
 *   x      left edge, percent of viewport WIDTH
 *   y      top edge, percent of viewport HEIGHT
 *   width  percent of the horizontal space FROM x to the viewport right edge,
 *          so width 100 always reaches the right edge regardless of x. In viewport
 *          units that is `(100 - x) * width / 100` vw.
 *
 * Height is dynamic (grows to fit, scrolls inside) and capped to the space below
 * y so the popup never runs off the bottom. A min-width floor keeps a popup at
 * high x on a narrow phone from getting too thin, and a right-edge cap keeps it
 * on-screen (overflow-safe).
 */

const GUTTER_PX = 12;
// Floor itself capped to the viewport so it can never overflow a narrow phone.
const MIN_WIDTH = 'min(260px, calc(100vw - 24px))';

const clampPct = (v) => {
  const n = typeof v === 'number' && Number.isFinite(v) ? v : 0;
  return Math.min(100, Math.max(0, n));
};

/**
 * Convert a `placement` into fixed-position CSS for the popup.
 * @param {{x:number,y:number,width:number}} placement
 * @returns {{left:string, top:string, width:string, maxHeight:string}}
 */
export const placementToStyle = (placement) => {
  const x = clampPct(placement && placement.x);
  const y = clampPct(placement && placement.y);
  const width = clampPct(placement && placement.width);
  const preferredVw = ((100 - x) * width) / 100;
  return {
    left: `${x}%`,
    top: `${y}%`,
    width: `clamp(${MIN_WIDTH}, ${preferredVw}vw, calc(100vw - ${x}% - ${GUTTER_PX}px))`,
    maxHeight: `calc(100vh - ${y}% - ${GUTTER_PX}px)`,
  };
};
